exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1mgh1WcvotUSnubiepyLPA{display:-webkit-box;display:-ms-flexbox;display:flex;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._1mgh1WcvotUSnubiepyLPA{border-bottom:1px solid \"[theme:neutralTertiaryAlt, default:#c8c8c8]\";padding-bottom:10px;margin-bottom:5px}._2FQXX10b3vCWwOj8U0Z6cV{-webkit-box-flex:1;-ms-flex:1;flex:1}._2Nvd-VQpgwj8ocK16UIXDx{color:\"[theme:themePrimary, default:#0078D4]\"}", ""]);

// exports
exports.locals = {
	"container": "_1mgh1WcvotUSnubiepyLPA",
	"resetButton": "_2FQXX10b3vCWwOj8U0Z6cV",
	"enableFlightsButton": "_2Nvd-VQpgwj8ocK16UIXDx"
};